import { api } from '../api';

export const identifyUserType = async (token: string): Promise<string> => {
  const { data } = await api.get('/users/identifyType', {
    params: { token: String(token) },
  });

  return data;
};
